module.exports = __webpack_public_path__ + "img/singleProduct.a855aecb.jpg";